<app-dashboard-card class="tickets-info-card">
  <ng-container card-title-icon>
    <mat-icon>local_activity</mat-icon>
  </ng-container>

  <ng-container card-title-content>
    <div class="header-container">
      <h2>Informações sobre ingressos</h2>
      <span class="header-info">
        Visualizar por
        <mat-button-toggle-group [formControl]="daysInterval" [hideSingleSelectionIndicator]="true">
          <mat-button-toggle value="M">último mês</mat-button-toggle>
          <mat-button-toggle value="W">última semana</mat-button-toggle>
        </mat-button-toggle-group>
      </span>
    </div>
  </ng-container>

  <ng-container card-content>
    <div class="content-grid">
      @if (ticketsInfo) {
        <app-ticket-info-card class="area-sold">
          <ng-container label> Ingressos vendidos </ng-container>

          <ng-container value>
            {{ ticketsInfo.paid | number }}
          </ng-container>
        </app-ticket-info-card>

        <app-ticket-info-card class="area-refunded">
          <ng-container label> Reembolsados </ng-container>

          <ng-container value>
            {{ ticketsInfo.refunded | number }}
          </ng-container>
        </app-ticket-info-card>

        <app-ticket-info-card class="area-receivable">
          <ng-container label> Ingressos transferidos </ng-container>

          <ng-container value>
            {{ ticketsInfo.receivable | number }}
          </ng-container>
        </app-ticket-info-card>

        <app-ticket-info-card class="area-complimentary">
          <ng-container label> Ingressos cortesia </ng-container>

          <ng-container value>
            {{ ticketsInfo.complimentary | number }}
          </ng-container>
        </app-ticket-info-card>
      } @else {
        <p-skeleton height="4rem" />
        <p-skeleton height="4rem" />
        <p-skeleton height="4rem" />
        <p-skeleton height="4rem" />
      }
    </div>
  </ng-container>
</app-dashboard-card>
